<template>
    <div class="summary">
        <div class="summary_bag">
            <!-- 选择 -->
            <div class="summary_top_shop">
                <div class="role-Choice">
                    <span>选择店铺：</span>
                    <el-select v-model="qvalue" @change="shopChange" placeholder="请选择">
                        <el-option v-for="item in ShopList" :key="item.shopId" :label="item.shopName"
                            :value="item.shopId" :style="{color: item.state1 === 0 ? 'red' : ''}"></el-option>
                    </el-select>
                </div>
            </div>
            <!-- 状态 -->
            <div class="summary_complete_bag">
                <!-- 完成 和未完成 -->
                <!-- v-show="completex" -->
                <div class="summary_complete" v-show="completex">
                    <div @click="complete(1)" v-bind:class="{ active: type === 1 }">已完成({{ finishedConut }})个</div>
                    <!-- <div
                        @click="complete(2)"
                        v-bind:class="{active: type === 2}"
                        style="margin-left: 10px;"
                    >翻译中(5)个</div>-->
                    <div @click="complete(3)" v-bind:class="{ active: type === 3 }" style="margin-left: 10px;">
                        未完成({{ unfinishedConut }})个
                    </div>
                </div>
                <div v-show="singleCompletex" class="summary_complete">
                    <div class="div1" @click="singleComplete(1)" :class="{ active: singletype === 1 }">待发布({{ startRow }})个</div>
                    <div class="div1" @click="singleComplete(2)" :class="{ active: singletype === 2 }" style="margin-left: 10px;">
                        发布中({{ endRow }})个
                    </div>
                    <div class="div1" @click="singleComplete(3)" :class="{ active: singletype === 3 }" style="margin-left: 10px;">
                        发布失败({{ prePage }})个
                    </div>
                    <div class="div1" @click="singleComplete(4)" :class="{ active: singletype === 4 }" style="margin-left: 10px;">
                        发布成功({{ nextPage }})个
                    </div>
                    <div class="select-div" v-if="subAccountSelect.length > 0">
                        当前账号是多人共用账号，请选择用户：
                        <el-select filterable clearable v-model="selectUser" placeholder="请选择用户" style="width: 120px; margin-left: 10px;">
                            <el-option :label="item.username + '--' + item.keywords" :value="item.uid" v-for="(item, index) in subAccountSelect" :key="index"></el-option>
                        </el-select>
                    </div>
                </div>
                
                <!-- 时间 -->
                <div class="summary_Date">
                    <div class="block w12">
                        <span>日期类型：</span>
                        <el-select v-model="dateType" placeholder="请选择" style="width: 120px">
                            <el-option label="创建时间" value="create_time"></el-option>
                            <el-option label="更新时间" value="update_time"></el-option>
                        </el-select>
                    </div>
                    <div class="block">
                        <span class="demonstration">选择开始日期：</span>
                        <el-date-picker v-model="startTime" align="right" type="datetime" placeholder="选择日期"
                            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </div>
                    <div class="block">
                        <span class="demonstration">选择结束日期：</span>
                        <el-date-picker v-model="endTime" align="right" type="datetime" placeholder="选择日期"
                            format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    </div>
                    <div class="block">
                        <el-input class="w90" v-model="idTitleSkuList" clearable placeholder="ID、SKU查询，多个用,隔开"></el-input>
                    </div>
                    <div class="block">
                        <el-input v-model="input" clearable placeholder="ID、标题、SKU"></el-input>
                        <span class="demonstration search" @click="serach(1)">搜索</span>
                    </div>
                </div>
            </div>
            <!-- 符合查询条件的产品共-->
            <div class="summary_pagenum">
                <div class="summary_query">
                    符合查询条件的产品共
                    <span>{{ count }}</span>
                    件
                </div>
            </div>
            <div class="summary_content">
                <div class="summary_batch">
                    <div>
                        <span style="border-left:0">已选择产品{{ piece }}件</span>
                    </div>
                    <div v-show="completex">
                        <!-- <span @click="edit">批量编辑</span> -->
                        <!-- <span @click="translate">批量翻译</span> -->
                        <span @click="del">批量删除</span>
                        <!-- <span @click="Testing">批量检测</span> -->
                    </div>
                    <div v-show="singleCompletex">
                        <div v-show="singletype === 1">
                            <span @click="release('all')">批量发布</span>
                            <!-- <span @click="edit">批量编辑</span> -->
                            <span @click="del">批量删除</span>
                        </div>

                        <div v-show="singletype === 2">
                            <span v-show="isShowBatchBack" @click="reductionProduct(true)">还原</span>
                        </div>
                        <div v-show="singletype === 3">
                            <!-- <span @click="edit">添加到待发布</span> -->
                            <span @click="reductionProduct(false)">批量还原</span>
                            <span @click="del">批量删除</span>
                        </div>
                        <!-- <div v-show="singletype === 4">
                            <span @click="edit">还原到待发布</span>
                        </div>-->
                        <div v-show="singletype === 4">
                            <span @click="reductionProduct(false)">批量还原</span>
                            <!-- <span @click="edit">添加到待发布</span> -->
                            <!-- <span @click="changeEANUPC('batch')">批量修复串图</span> -->
                            <span @click="repairInfo('all', 2)">批量修复变体/串图</span>
                            <span @click="repairInfo('all', 3)">批量修复图片缺失</span>
                            <span @click="openComponentsDialog('ModifyPrice')">修改/批量修改价格</span>
                            <span @click="openComponentsDialog('ModifyStock')">修改/批量修改价格库存</span>
                        </div>
                    </div>
                </div>
                <div class="summary_list">
                    <!-- 头部-->
                    <el-table ref="multipleTable" :data="summarylist" style="width: 100%" v-loading="load_data"
                        element-loading-text="拼命加载中" border @selection-change="on_batch_select"
                        :header-cell-style="iscenter" stripe>
                        <!-- :cell-style="style" -->
                        <el-table-column width="50" type="selection" align="center"
                            v-if="singletype !== 2"></el-table-column>
                        <el-table-column width="200" label="产品ID" prop="productNumber" align="center"></el-table-column>
                        <el-table-column label="主图" width="140" align="center">
                            <template slot-scope="scope">
                                <el-popover trigger="hover" placement="right">
                                    <img :src="scope.row.productImgUrl" class="prduct_img" alt />
                                    <div class="scope_img" slot="reference">
                                        <img :src="scope.row.productImgUrl" alt />
                                    </div>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="title" label="标题"></el-table-column>
                        <el-table-column prop="titleDifferentiation" label="商品亮点"></el-table-column>
                        <el-table-column width="180" prop="sku" label="父SKU" align="center"></el-table-column>
                        <el-table-column width="140" prop="productPrice" label="价格" align="center">
                            <template slot-scope="scope">
                                <div>{{ itemPrice(scope.row) }}</div>
                                <!-- + (scope.row.priceCurrency?`(${scope.row.priceCurrency})`:'') -->
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="sourceLink" label="来源" width="180"></el-table-column> -->

                        <el-table-column width="100" label="来源" align="center">
                            <template slot-scope="scope">
                                <template v-if="scope.row.sourceLinks && scope.row.sourceLinks.length">
                                    <template v-for="(item, index) in scope.row.sourceLinks">
                                        <div>
                                            <el-link :href="item" target="_blank" type="primary">
                                                {{ "BUY" + (scope.row.sourceLinks.length > 1 ? index + 1 : "") }}
                                            </el-link>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <div>暂无</div>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column width="100" prop="checkStatus" label="校验结果" align="center">
                            <template slot-scope="scope">
                                <div :class="scope.row.checkStatus === 1 ? 'green-box' : 'red-box'">
                                    <span>{{ scope.row.checkStatus === 1 ? '通过' : '不通过' }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column width="200" prop="updateTime" label="更新时间" align="center"
                            v-if="singletype === 1"></el-table-column>
                        <el-table-column width="200" prop="submitTime" label="创建时间" align="center"
                            v-else-if="singletype === 2"></el-table-column>
                        <el-table-column width="200" prop="uploadTime" label="上传时间" align="center"
                            v-else-if="singletype === 3"></el-table-column>
                        <el-table-column width="200" prop="uploadTime" label="发布时间" align="center"
                            v-else-if="singletype === 4"></el-table-column>
                        <el-table-column label="操作" fixed="right" width="150" align="center">
                            <template slot-scope="props">
                                <template v-if="singletype !== 2">
                                    <!-- <el-tooltip
                                        class="item"
                                        effect="dark"
                                        content="编辑"
                                        placement="bottom"
                                        v-if="[1, 3].includes(singletype)"
                                    >
                                        <router-link
                                            :to="{
                                                name: 'editProduct',
                                                params: { id: props.row.id, pageType: 'wait' },
                                            }"
                                            style="display: inline-block;height: 100%;"
                                        >
                                            <el-button type="primary" icon="el-icon-edit"></el-button>
                                        </router-link>
                                    </el-tooltip> -->
                                    <el-tooltip class="item" effect="dark" content="发布" placement="bottom"
                                        v-if="singletype === 1">
                                        <el-button type="success" icon="el-icon-upload2"
                                            @click="clickRelease(props.row)" style="margin-left: 10px;"></el-button>
                                    </el-tooltip>
                                    <template v-if="singletype === 3">
                                        <el-tooltip class="item" effect="dark" content="失败原因" placement="bottom">
                                            <el-button type="warning" icon="el-icon-document"
                                                @click="resultVisible(props.row)"
                                                style="margin-left: 10px;"></el-button>
                                        </el-tooltip>
                                    </template>
                                    <el-tooltip class="item" effect="dark" content="删除" placement="bottom">
                                        <el-button type="danger" icon="el-icon-delete" @click="removeId(props.row)"
                                            v-if="singletype !== 4"></el-button>
                                    </el-tooltip>
                                    <template v-if="singletype === 4">
                                        <div class="oper" @click="resultVisible(props.row)" v-if="
                                            props.row.handleUploadResult &&
                                            props.row.handleUploadResult.totalResult !== 'success'
                                        ">
                                            查看警告信息
                                        </div>
                                        <div>
                                            <!-- <el-tooltip class="item" effect="dark" content="查看产品" placement="bottom">

                                                <router-link :to="{
                                                    name: 'editProduct',
                                                    params: { id: props.row.id, pageType: 'complete' },
                                                }">
                                                    <el-button type="text">查看</el-button>
                                                </router-link>
                                            </el-tooltip> -->
                                        </div>
                                        <!-- <div>
                                            <el-tooltip class="item" effect="dark" content="修复后台显示其他商品图片的问题"
                                                placement="bottom">
                                                <el-button type="text" @click="changeEANUPC('success', props.row)">
                                                    修复串图
                                                </el-button>
                                            </el-tooltip>
                                        </div> -->
                                        <div>
                                            <el-button type="text" @click="repairInfo('single', 2, props.row)"
                                                v-if="props.row.variantId">
                                                批量修复变体/串图
                                            </el-button>
                                        </div>
                                        <div>
                                            <el-button type="text" @click="repairInfo('single', 3, props.row)">
                                                修复图片缺失
                                            </el-button>
                                        </div>
                                        <!-- <div
                                            class="oper"
                                            @click="repairInfo('single', 2, props.row)"
                                            v-if="props.row.variantId"
                                        >
                                            修复变体关系
                                        </div>
                                        <div class="oper" @click="repairInfo('single', 3, props.row)">修复图片缺失</div> -->
                                    </template>
                                </template>
                                <template v-else>
                                    <span>发布中不可操作</span>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="summary_pagenum_block">
                <div class="block">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage4" :page-sizes="[10, 20, 50, 100]"
                        layout="total, sizes, prev, pager, next, jumper" :total="count"></el-pagination>
                </div>
            </div>
        </div>
        <!-- 查看结果：失败原因/成功警告 -->
        <el-dialog class="custom-dialog" :title="resultData.productNumber" :visible.sync="resultDialogVisible"
            width="50%" :close-on-click-modal="false" top="4vh">
            <div v-if="errorMessages.length > 0">
                <h2>错误信息</h2>
                <ul>
                    <li class="mT-10" v-for="(error, index) in errorMessages" :key="index">
                        <strong>商品Sku: </strong> <span style="color: red;">{{ error.product }}</span><br>
                        <strong>错误代码: </strong> {{ error.code }}<br>
                        <strong>字段: </strong> <span style="color: blue;">{{ error.attribute }}</span><br>
                        <strong>错误消息: </strong> {{ error.message }}
                    </li>
                </ul>
            </div>
            <div v-else>
                <p>没有错误信息</p>
            </div>
            <div slot="footer">
                <el-row type="flex" justify="space-between" align="middle">
                    <div style="color: red;">如果是EAN或UPC所产生的错误，重新上传即可</div>
                    <!-- <el-button
                        type="danger"
                        size="small"
                        @click="failChangeEANUPC('all')"
                        :disabled="failChangeEANUPCDisabled"
                    > -->
                    <!-- <el-button
                        type="danger"
                        size="small"
                        @click="failChangeEANUPC('all')"
                        :loading="failChangeAllEANUPCLoading"
                        :disabled="failChangeEANUPCDisabled"
                    >
                        置换全部EAN/UPC
                    </el-button>
                    <el-button type="danger" size="small" @click="changeSkuDialogVisible = !changeSkuDialogVisible">
                        置换部分EAN/UPC
                    </el-button> -->
                    <!-- <el-button type="success" size="small" @click="failTranslateResult" -->
                    <!-- :loading="failTranslateResultLoading" :disabled="failTranslateResultDisabled"> -->
                    <!-- <el-button
                        type="success"
                        size="small"
                        @click="failTranslateResult"
                        :loading="failTranslateResultLoading"
                        :disabled="failTranslateResultDisabled"
                    > -->
                    <!-- 翻 译 -->
                    <!-- </el-button> -->
                    <el-button type="primary" size="small" @click="resultDialogVisible = false">确 定</el-button>
                </el-row>
                <div v-show="changeSkuDialogVisible" style="margin-top:10px;">
                    <el-row>
                        <el-input type="textarea" :rows="3" placeholder="请输入内容" v-model="changeSkus"></el-input>
                    </el-row>
                    <el-row style="margin-top:10px;" type="flex" justify="space-between" align="middle">
                        <h4>请输入要置换的SKU,用英文逗号[ , ]隔开</h4>
                        <el-button type="primary" size="small" @click="failChangeEANUPC('single')"
                            :disabled="failChangeEANUPCDisabled">
                            <!-- <el-button
                            type="primary"
                            size="small"
                            @click="failChangeEANUPC('single')"
                            :loading="failChangeEANUPCLoading"
                            :disabled="failChangeEANUPCDisabled"
                        > -->
                            一键置换EAN/UPC
                        </el-button>
                    </el-row>
                </div>
            </div>
        </el-dialog>
        <commodity-frame ref="CommodityFrame"></commodity-frame>
        <!-- 分类模型 -->
        <uploadProduct ref="uploadProduct" :area-name="areaName" @submitOuterForm="submitOuterForm" />
        <releaseProduct :publishInfo="publishInfo" :isChakan="isChakan" :system="system" ref="releaseProduct" :sellerCommonSetting="sellerCommonSetting"
            @refreshTable="serach(1)" :area-name="areaName" :aiPower="aiPower" :selectUser="selectUser" :subAccountSelect="subAccountSelect" ></releaseProduct>
        <modify-price ref="ModifyPrice" @close="closeComponentsDialog" />
        <modify-stock ref="ModifyStock" @close="closeComponentsDialog" />
    </div>
</template>
<script>
let isUpdate = false;
import CommodityFrame from "./elasticFrame/commodityFrame.vue";
import uploadProduct from "./uploadProduct.vue";
import releaseProduct from "./releaseDialog.vue";
import ModifyPrice from './components/modifyPrice'
import ModifyStock from './components/modifyStock'
import { ajaxPost, Baseurl } from "../../../api/api/api";

export default {
    name: "summaryt",
    components: {
        CommodityFrame,
        uploadProduct,
        releaseProduct,
        ModifyPrice,
        ModifyStock
    },
    beforeRouteEnter(to, from, next) {
        // console.log(to, from)
        if (from.name === 'editProduct') {
            isUpdate = true
        } else {
            isUpdate = false
        }
        next()
    },
    data() {
        return {
            isChakan: false,
            system: JSON.parse(localStorage.getItem('role')).system,
            load_data: false,
            completex: false,
            singleCompletex: true,
            piece: 0,
            summary: "复制",
            iscenter: {
                textAlign: "center",
                background: "#f8f8f8",
                color: "#232323",
            },
            type: 1,
            count: 1,
            singletype: 1,
            value: "",
            startTime: "", //开始时间
            endTime: "", //结束时间
            input: "",
            setlist: false,
            currentPage4: 1,
            size: 10,
            checkAll: [],
            publishInfo: null,
            qvalue: "",
            summarylist: [],
            finishedConut: 0,
            unfinishedConut: 0,
            statusAudit: 2,
            batch_select: [],
            batch_select2: [],
            batch_select3: [],
            batch_select4: [],
            endRow: "",
            startRow: "",
            nextPage: "",
            prePage: "",
            areaName: "",
            UserInfo: {},
            ShopList: [],
            checkedStore: {},
            resultDialogVisible: false,
            changeSkuDialogVisible: false,
            resultData: {},
            errorMessages: [],
            failTranslateResultLoading: false,
            failTranslateResultDisabled: false,
            failChangeEANUPCLoading: false,
            failChangeAllEANUPCLoading: false,
            failChangeEANUPCDisabled: false,
            goBackCountry: "",
            changeSkus: "",
            aiPower: null,
            selectUser: '',
            subAccount: '',
            subAccountSelect: [],
            dateType: "create_time",
            idTitleSkuList: '',
            sellerCommonSetting: {},
        };
    },
    computed: {
        isShowBatchBack() {
            const result = this.summarylist.some((item) => {
                const date = new Date(item.submitTime).getTime()
                const nowDate = new Date().getTime()
                return (nowDate - date) > (10 * 3600 * 1000)
            })
            return result || false
        }
    },
    async mounted() {
        // ai功能权限
        const userData = JSON.parse(localStorage.getItem("data"));
        const user1 = userData.data.user;
        this.aiPower = user1.aiPower;
        this.subAccount = user1.subAccount;
        this.UserInfo = JSON.parse(localStorage.getItem("role"));
        if(this.subAccount){
            let sid = null;
            const rid = this.UserInfo.rid;
            await this.getSubAccountSelect(rid);
        }
        const goBackCountry = this.$route.params.country;
        if (goBackCountry) {
            this.goBackCountry = goBackCountry;
        }
        this.SelectTheStore();
    },
    activated() {
        if (isUpdate) this.getDate(1);
    },
    // computed: {
    //     isVisibleChangEANUPCBtn() {
    //         const handleData = this.resultData.handleUploadResult && this.resultData.handleUploadResult.productInfo;
    //         const arr = [];
    //         const str = "make sure that your data for standard_product_id is correct.";
    //         for (const item in handleData) {
    //             if (item.includes("Error")) {
    //                 const handleStr = JSON.stringify(handleData[item]);
    //                 arr.push(handleStr);
    //             }
    //         }
    //         const result = arr.some(item => item.includes(str));
    //         if (result) {
    //             return true;
    //         }
    //         return false;
    //     },
    // },
    methods: {
        async getSubAccountSelect(rid){
            const subAccountStr = this.subAccount;
            const res = await ajaxPost(Baseurl + "userControllers/getSubAccountSelect", {
                subAccountStr: subAccountStr,
                rid
            })
            const { code, data } = res.data;
            if (code === 200) {
                console.log(data);
                this.subAccountSelect = data;
            }
        },
        openComponentsDialog(componentsName) {
            if (!this.batch_select2.length) {
                this.$message.warning('请至少选择一条')
                return
            }
            this.$refs[componentsName].openDialog(
                this.batch_select2,
                this.qvalue
            )
        },
        closeComponentsDialog() {
            this.batch_select2 = []
        },
        clickRelease(value) {
            if(this.subAccountSelect.length > 0 && !this.selectUser){
                this.$message.warning('当前店铺为多人公用，请选择用户')
                return
            }
            let paramsData = {}
            paramsData.row = value
            for (let index = 0; index < JSON.parse(value.submitJson).length; index++) {
                if (JSON.parse(value.submitJson)[index].parentage_level != undefined) {
                    if (JSON.parse(value.submitJson)[index].attributes.parentage_level[0].value == "parent") {
                        paramsData.variant = JSON.parse(value.submitJson)[index]
                    }
                }
            }
            this.$nextTick(() => {
                this.publishInfo = paramsData
                for (let index = 0; index < this.ShopList.length; index++) {
                    if (this.qvalue == this.ShopList[index].shopId) {
                        this.publishInfo.sellerId = this.ShopList[index].sellerId
                    }
                }
                this.$refs.releaseProduct.openDialog(this.publishInfo, 1);
            })
        },
        itemPrice(item) {
            const itemPrice = item.productPrice
                ? item.productPrice + (item.priceCurrency ? `(${item.priceCurrency})` : "")
                : "";
            return itemPrice;
        },
        SelectTheStore() {
            var param = {
                rid: this.UserInfo.rid,
                system: this.UserInfo.system,
            };
            ajaxPost(Baseurl + "sellerController/selectMyFineShopByRid", param).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    if (!data.length) return;
                    var sellerInfos = data;
                    var newArr = [];
                    var num = 0;
                    for (var i = 0; i < sellerInfos.length; i++) {
                        var shop = sellerInfos[i].countryMarks;
                        const state = sellerInfos[i]['state'];
                        for (var j = 0; j < shop.length; j++) {
                            shop[j].sellerId = sellerInfos[i].sellerId;
                            shop[j].mwsAuthToken = sellerInfos[i].mwsAuthToken;
                            shop[j]['state1'] = state;
                            newArr[num] = shop[j];
                            num++;
                        }
                    }
                    this.ShopList = newArr.sort((a, b) => a.order - b.order);
                    let countryIndex = 0;
                    if (this.goBackCountry) {
                        countryIndex = this.ShopList.findIndex(item => item.countryMark === this.goBackCountry);
                    }
                    this.qvalue = this.ShopList[countryIndex].shopId;
                    this.areaName = this.ShopList[countryIndex].countryMark;
                    this.checkedStore = this.ShopList[countryIndex];

                    const params = {
                        countrySellerId: this.ShopList[countryIndex].shopId,
                        countryMark: this.ShopList[countryIndex].countryMark,
                    }
                    this.sellerCommonSetting = {};
                    ajaxPost(Baseurl + 'sellerCommonSettingController/getSellerCommonSettingByCountrySellerId', params).then(res => {
                        if (res.data.code == 200) {
                            this.sellerCommonSetting = res.data.data;
                        }
                    })
                    this.getDate(1);
                    // console.log(this.ShopList)
                    // this.storeInfo = sellerInfos;
                }
            });
        },
        async serach(curPage = 1) {
            await this.$nextTick(); 
            this.getDate(curPage);
        },
        on_batch_select(val) {
            var delarr = [];
            var fabuarr = [];
            var huanYuanArr = [];
            this.piece = val.length;
            console.log(val);

            for (var i = 0; i < val.length; i++) {
                delarr.push({
                    id: val[i].listingId,
                    productId: val[i].id
                });
                if (val[i].checkStatus === 1) {
                    fabuarr.push(
                        val[i].listingId
                    );
                }
                huanYuanArr.push(val[i].id);
            }
            this.batch_select = delarr;
            this.batch_select2 = val;
            this.batch_select3 = fabuarr;
            this.batch_select4 = huanYuanArr;
        },
        getDate(currentPage) {
            this.currentPage4 = currentPage;
            this.load_data = true;
            ajaxPost(Baseurl + "amazonProductListing/selectAmazonProductListings", {
                page: currentPage,
                size: this.size,
                staffId: this.UserInfo.rid, //登录人id
                startTime: this.startTime,
                endTime: this.endTime,
                idTitleSku: this.input,
                areaName: this.areaName,
                releaseStatus: this.singletype,
                dateType: this.dateType,
                idTitleSkuList: this.idTitleSkuList.split(",").filter(item => item),
            })
                .then(res => {
                    this.load_data = false;
                    const { code, data } = res.data;
                    if (code === 200) {
                        if (data.list !== "") {
                            this.count = data.total;
                            // this.unfinishedConut = data.navigateLastPage;
                            // this.finishedConut = data.navigateFirstPage;
                            this.startRow = data.startRow;
                            this.endRow = data.endRow;
                            this.nextPage = data.nextPage;
                            this.prePage = data.prePage;
                            data.list.forEach(item => {
                                if (item.uploadResult) {
                                    const handleData = (item.handleUploadResult = JSON.parse(item.uploadResult));
                                    for (const key in handleData) {
                                        handleData.totalResult = handleData[key].result;
                                        if (handleData.totalResult !== "success") {
                                            break;
                                        }
                                    }
                                }
                            });
                            this.summarylist = data.list;
                        }
                    }
                })
                .catch(function (e) {
                    console.log(e);
                });
        },
        getIds(type, row) {
            let ids = [];
            if (type === "all") {
                ids = this.batch_select;
            } else {
                ids = [row.id];
            }
            return ids.sort();
        },

        // 待发布 上传 操作
        release(type) {
            if (this.subAccountSelect.length > 0 && !this.selectUser) {
                this.$message.warning('当前店铺为多人公用，请选择用户')
                return
            }
            if (type === "all" && this.piece == 0) {
                if (this.piece == 0) {
                    this.$alert("请至少勾选一件产品或有选择校验不通过的产品！", "提示", {
                        confirmButtonText: "确定",
                    });
                    return
                }
            } else {
                if (this.batch_select3.length != 0) {
                    let uid = null;
                    if(localStorage.getItem("data")){
                        uid = JSON.parse(localStorage.getItem('data')).data.user.uid;
                    }
                    ajaxPost(Baseurl + "amazonProductListing/batchReleaseAmazonProductListings",
                        { listingIds: this.batch_select3, rid: this.UserInfo.rid, uid },
                    ).then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                type: "success",
                                message: "发布成功!",
                            });
                            this.getDate(this.currentPage4);
                        }
                    });
                } else {
                    this.$alert("请至少勾选一件产品或有选择校验不通过的产品！", "提示", {
                        confirmButtonText: "确定",
                    });
                    this.getDate(this.currentPage4);
                    return
                }
            }
        },
        // 修复变体关系 修复图片缺失
        repairInfo(type, operate, row) {
            if (type === "all" && this.piece == 0) {
                this.$alert("请至少勾选一件产品！", "提示", {
                    confirmButtonText: "确定",
                });
                return;
            }
            let str1 = "";
            let str2 = "";
            if (type === "all") {
                str1 = "批量";
                if (operate === 2) {
                    const isVariantResult = this.batch_select2.every(item => item.variantId);
                    if (!isVariantResult) {
                        this.$alert("所选项中有包含无变体的产品，无法批量修复变体关系，请重新选择！", "提示");
                        return;
                    }
                }
            }
            if (operate === 2) {
                str2 = "修复变体关系";
            } else if (operate === 3) {
                str2 = "修复图片缺失";
            }
            this.$confirm(`确定${str1}${str2}？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            })
                .then(() => {
                    let url = null;
                    let params = {}
                    if (operate === 2) {
                        url = 'amazonProductListing/repairAmazonListingRelationships';
                        params = {
                            companyId: this.UserInfo.company_id
                        }
                    } else if (operate === 3) {
                        url = "amazonProductListing/repairAmazonListingImages";
                    }
                    if (type === 'all') {
                        ajaxPost(Baseurl + url,
                            { listingIds: this.batch_select3, rid: this.UserInfo.rid, ...params },
                        ).then(res => {
                            if (res.data.code == 200) {
                                this.$message({
                                    type: "success",
                                    message: "修复成功!",
                                });
                                this.getDate(this.currentPage4);
                            }
                        });
                    } else {
                        ajaxPost(Baseurl + url,
                            { listingIds: [row.listingId], rid: this.UserInfo.rid, ...params },
                        ).then(res => {
                            if (res.data.code == 200) {
                                this.$message({
                                    type: "success",
                                    message: "修复成功!",
                                });
                                this.getDate(this.currentPage4);
                            }
                        });
                    }
                })
                .catch(() => {
                    this.$message("取消操作");
                });
        },
        // 编辑
        editId(id) {
            this.$router.push({
                path: "/commodity/product/EstablishProduct",
                query: {
                    id: id,
                },
            });
        },
        // 还原
        reductionProduct(isAutoChecked = false) {
            let ids = []
            let productNumber = []
            if (isAutoChecked) {
                const arr = this.summarylist.filter(item => {
                    const date = new Date(item.submitTime).getTime()
                    const nowDate = new Date().getTime()
                    return (nowDate - date) > (10 * 3600 * 1000)
                })
                ids = arr.map(item => item.id)
                productNumber = arr.map(item => item.productNumber)
            } else {
                if (!this.batch_select4.length) {
                    this.$alert("请至少勾选一件产品！", "提示");
                    return;
                }
                ids = this.batch_select4
            }
            const request = () => {
                const API = Baseurl + "productController/reductionProductById";
                const paramsData = {
                    ids,
                    releaseStatus: "1",
                };
                ajaxPost(API, paramsData).then(res => {
                    const { code } = res.data;
                    if (code == 200) {
                        this.$message({
                            type: "success",
                            message: "还原成功!",
                        });
                        this.singletype = 1;
                        this.getDate(this.currentPage4);
                    }
                });
            };
            let tips = "确定要还原选中的产品吗？"

            if (isAutoChecked) {
                tips = `确定要还原${productNumber.join('、')}的产品吗？`
            }
            this.$confirm(tips, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            })
                .then(() => {
                    request();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消操作",
                    });
                });
        },
        // 删除
        removeId(val) {
            var newarr = [];
            newarr.push({ id: val.listingId, productId: val.id });
            this.$confirm("此操作将永久删除该产品, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    ajaxPost(Baseurl + "amazonProductListing/deleteAmazonProductListingById",
                        newarr,
                    ).then(res => {
                        if (res.data.code == 200) {
                            this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            const totalSize = Math.ceil((this.count - 1) / this.size); //判断当前页是否小于删除之后的总页，小于或者等于继续使用，大于-1
                            if(this.currentPage4 <= totalSize){
                                this.getDate(this.currentPage4);
                            }else{
                                this.getDate(this.currentPage4 - 1);
                            }
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        // 复制
        copy(id) {
            ajaxPost(Baseurl + "productController/copyProductById", {
                id: id,
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message({
                        type: "success",
                        message: "复制成功!",
                    });
                }
            });
        },
        Selection(item) {
            if (item.chatype) {
                this.piece++;
            } else {
                this.piece--;
            }
        },
        singleComplete(val) {
            this.singletype = val;
            this.statusAudit = 2;
            // if (val == 2) {
            //     // this.type = 0;
            // }
            this.getDate(1);
        },
        complete(index) {
            this.type = index;
            if (index == 1) {
                this.singletype = null;
                this.statusAudit = 2;
            } else {
                this.singletype = null;
                this.statusAudit = 1;
            }
            this.getDate(1);
        },
        handleSizeChange(val) {
            this.size = val;
            this.getDate(1);
        },
        handleCurrentChange(val) {
            this.currentPage4 = val;
            this.getDate(val);
        },
        // 显示 隐藏
        setdisplay(item) {
            item.settype = !item.settype;
        },
        shopChange(event) {
            this.checkedStore = this.ShopList.find(item => item.shopId === event);
            this.areaName = this.checkedStore.countryMark;
            const params = {
                countrySellerId: this.checkedStore.shopId,
                countryMark: this.checkedStore.countryMark,
            }
            this.sellerCommonSetting = {};
            ajaxPost(Baseurl + 'sellerCommonSettingController/getSellerCommonSettingByCountrySellerId', params).then(res => {
                if(res.data.code == 200){
                    this.sellerCommonSetting = res.data.data;
                }
            })
            // if (item == "") {
            //     this.completex = true;
            //     this.singleCompletex = false;
            //     this.summary = "上传";
            // } else {
            //     this.completex = false;
            //     this.singleCompletex = true;
            //     this.summary = "复制";
            // }
            // if (item == 1) {
            //     this.singletype = 1;
            // } else if (item == 0) {
            //     this.singletype = null;
            // }
            this.getDate(1);
        },

        edit() {
            if (this.piece == 0) {
                this.$alert("请至少勾选一件产品！", "提示", {
                    confirmButtonText: "确定",
                });
            } else {
                this.$refs.CommodityFrame.init(this.batch_select2); //子级的init
            }
        },
        translate() {
            if (this.piece == 0) {
                this.$alert("请至少勾选一件产品！", "提示", {
                    confirmButtonText: "确定",
                });
            } else {
                this.$confirm("确定要批量翻译吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.$message({
                            type: "success",
                            message: "批量成功!",
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消批量",
                        });
                    });
            }
        },
        Testing() {
            if (this.piece == 0) {
                this.$alert("请至少勾选一件产品！", "提示", {
                    confirmButtonText: "确定",
                });
            } else {
                this.$confirm("确定要批量检测吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        this.$message({
                            type: "success",
                            message: "检测成功!",
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消检测",
                        });
                    });
            }
        },
        del() {
            if (this.piece == 0) {
                this.$alert("请至少勾选一件产品！", "提示", {
                    confirmButtonText: "确定",
                });
            } else {
                this.$confirm("此操作将永久删除该产品, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        ajaxPost(Baseurl + "amazonProductListing/deleteAmazonProductListingById",
                            this.batch_select,
                        ).then(res => {
                            if (res.data.code == 200) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功!",
                                });
                                const totalSize = Math.ceil((this.count - this.batch_select.length) / this.size); //判断当前页是否小于删除之后的总页，小于或者等于继续使用，大于-1
                                if(this.currentPage4 <= totalSize){
                                    this.getDate(this.currentPage4);
                                }else{
                                    this.getDate(totalSize);
                                }
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: "info",
                            message: "已取消删除",
                        });
                    });
            }
        },
        editList() {
            this.$router.push({
                path: "/commodity/product/EstablishProduct",
                query: {
                    substitutionFalse: false,
                    substitutionTrue: true,
                },
            });
        },
        Choiceproduct(val) {
            this.summarylist.forEach(ele => {
                if (val) {
                    this.arr.push(ele.id);
                    ele.chatype = true;
                    this.piece = this.summarylist.length;
                } else {
                    ele.chatype = false;
                    this.piece = "0";
                }
            });
            // 批量删除
            console.log(this.arr);
        },
        // 上传提交
        submitOuterForm(data, type = 1) {
            const API = Baseurl + "amaoznFeedUpload/uploadAmazonFeed";
            const paramsData = {
                type, // 待发布上传 type值等于1；修复变体关系 type=2；修复图片缺失 type=3
                rid: this.UserInfo.rid,
                ids: JSON.stringify(data.ids),
                content: JSON.stringify(data.content),
                categoryId: data.categoryId,
                contentType: data.templateValue,
                // countrySellerId: this.checkedStore.shopId,
                sellerId: this.checkedStore.sellerId,
                marketInfo: JSON.stringify({
                    sellerId: this.checkedStore.sellerId,
                    mwsAuthToken: this.checkedStore.mwsAuthToken,
                    countryMark: this.checkedStore.countryMark,
                    marketplaceId: this.checkedStore.marketPlaceId,
                }),
            };
            ajaxPost(API, paramsData)
                .then(res => {
                    const { code, data, message } = res.data;
                    if (code === 200) {
                        this.$refs.uploadProduct.saveLatelyClassify();
                        this.$refs.uploadProduct.close();
                        this.$message.success(data);
                        if (type === 1) {
                            this.singleComplete(2);
                        }
                    } else if (code === 300) {
                        this.$refs.uploadProduct.saveLatelyClassify();
                        this.$refs.uploadProduct.close();
                        this.$message.warning(data);
                    } else {
                        this.$message.error(message);
                    }
                })
                .catch(() => {
                    this.$message.error("发布出错");
                });
        },
        resultVisible(item) {
            this.resultDialogVisible = true;
            this.resultData = item;
            this.processErrors(this.resultData.handleUploadResult.productInfo)
            this.failTranslateResultLoading = false;
            this.failTranslateResultDisabled = false;
            this.failChangeEANUPCLoading = false;
            this.failChangeEANUPCDisabled = false;
            this.changeSkuDialogVisible = false;
            this.changeSkus = "";
        },
        processErrors(productInfo) {
            let formattedErrors = [];
            for (let errorGroup in productInfo) {
                if (errorGroup !== 'result' && errorGroup !== 'totalResult') {
                    const products = productInfo[errorGroup];
                    for (let product in products) {
                        const errors = products[product];
                        errors.forEach(error => {
                            formattedErrors.push({
                                product: product,
                                code: error.code,
                                attribute: error.attributeName,
                                message: error.code === "90220"
                                    ? `'${error.attributeName}' 是必填字段，但未提供。`
                                    : error.message
                            });
                        });
                    }
                }
            }
            // 更新错误信息
            this.errorMessages = formattedErrors;
        },
        failTranslateResult() {
            this.failTranslateResultLoading = true;
            const API = Baseurl + "transcationControllor/transcationReason";
            const paramsData = {
                uploadResult: this.resultData.uploadResult,
            };
            ajaxPost(API, paramsData)
                .then(res => {
                    this.failTranslateResultLoading = false;
                    this.failTranslateResultDisabled = true;
                    this.$set(this.resultData, "handleTranslateUploadResult", res.data);
                })
                .catch(() => {
                    this.failTranslateResultLoading = false;
                    this.$message.success("操作有误");
                });
        },
        // 修复串图 一键置换EAN/UPC
        changeEANUPC(type, row) {
            if (type === "batch") {
                if (this.piece == 0) {
                    this.$alert("请至少勾选一件产品！", "提示");
                    return;
                } else {
                    row = this.batch_select;
                }
            }
            const handleRequest = () => {
                // row 是数组或对象，数组是多选的时候
                let ids = Array.isArray(row) ? row : [row.id];
                const API = Baseurl + "productController/resetErrorEanUpc";
                const paramsData = {
                    ids,
                    companyId: this.UserInfo.company_id,
                    type: 2, // 发布成功置换 type === 2 ，发布失败置换 type === 1
                };
                this.$message.success('加入上传队列，请等待上传结果。。。');
                ajaxPost(API, paramsData)
                    .then(res => {
                        const { code, data } = res.data;
                        if (code === 200) {
                            // this.$message.success(data);
                            this.resultDialogVisible = false;
                            this.singletype = 2;
                            this.getDate(1);
                        } else {
                            this.$message.warning(data);
                        }
                    })
            };
            this.$confirm(
                "点击确定之后将会置换EAN/UPC码，重新上传之后可能导致原有SKU无法识别！您确定要重置吗？",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    handleRequest();
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消操作",
                    });
                });
        },
        async failChangeEANUPC(type = "single") {
            if (type === "single" && !this.changeSkus) {
                this.$alert("请输入要置换商品的SKU！", "提示");
                return;
            }
            const firstRequest = async () => {
                type === "single" ? (this.failChangeEANUPCLoading = true) : (this.failChangeAllEANUPCLoading = true);
                const API = Baseurl + "productController/getSkusByProductId";
                const paramsData = {
                    id: this.resultData.id,
                };
                const { data: { data } } = await ajaxPost(API, paramsData);
                return data;
            };
            const productSku = await firstRequest();
            let skus = [];
            if (type === "single") {
                skus = this.changeSkus
                    .split(/,|，|\n/)
                    .filter(item => !!item)
                    .map(item => item.trim());
                skus = [...new Set(skus)];
                for (const item of skus) {
                    const result = productSku.includes(item);
                    if (!result) {
                        this.$message.error(`${item}，此SKU不合法！`);
                        type === "single" ? (this.failChangeEANUPCLoading = false) : null;
                        return;
                    }
                }
            } else {
                skus = productSku;
            }
            const handleRequest = () => {
                const API = Baseurl + "productController/resetEanUpc";
                const paramsData = {
                    id: this.resultData.id,
                    companyId: this.UserInfo.company_id,
                    type: 1, // 发布成功置换 type === 2 ，发布失败置换 type === 1
                    skus,
                };
                // if (type === "fail") {
                //     this.failChangeEANUPCLoading = true;
                //     // const handleData =
                //     //     this.resultData.handleUploadResult && this.resultData.handleUploadResult.productInfo;
                //     // const str = "make sure that your data for standard_product_id is correct.";
                //     // for (const item in handleData) {
                //     //     const obj = handleData[item];
                //     //     if (Object.prototype.toString.call(obj) === "[object Object]") {
                //     //         const result = obj.description.includes(str);
                //     //         if (result) {
                //     //             skus = [...skus, ...obj.sku];
                //     //         }
                //     //     }
                //     // }
                //     paramsData.skus = this.changeSkus.split(/,|，|\n/);
                //     paramsData.type = 1;
                //     paramsData.id = [this.resultData.id];
                // }
                ajaxPost(API, paramsData)
                    .then(res => {
                        const { code, data } = res.data;
                        if (code === 200) {
                            this.failChangeEANUPCDisabled = true;
                            this.$message.success(data);
                        } else {
                            this.$message.warning(data);
                        }
                        this.singletype = 1;
                        this.singleComplete(1);
                        this.resultDialogVisible = false;
                    })
                    .finally(() => {
                        type === "single"
                            ? (this.failChangeEANUPCLoading = false)
                            : (this.failChangeAllEANUPCLoading = false);
                    });
            };
            this.$confirm(
                "点击确定之后将会置换EAN/UPC码，重新上传之后可能导致原有SKU无法识别！您确定要重置吗？",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    handleRequest();
                })
                .catch(() => {
                    type === "single"
                        ? (this.failChangeEANUPCLoading = false)
                        : (this.failChangeAllEANUPCLoading = false);
                    this.$message({
                        type: "info",
                        message: "已取消操作",
                    });
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.summary {
    width: 98%;
    padding-bottom: 72px;

    // background: #F7F7F7;
    .summary_bag {
        width: 98%;
        margin: auto;

        .summary_top_shop {
            width: 100%;
            height: 40px;
            border-bottom: 1px #eee solid;
            line-height: 40px;

            .role-Choice {
                width: 630px;
                float: left;

                span {
                    line-height: 30px;
                }

                .el-select {
                    width: 60%;
                }
            }
        }

        .summary_complete_bag {
            overflow: hidden;

            .summary_complete {
                overflow: hidden;
                padding: 10px 0;
                border-bottom: 1px #eee solid;
                display: flex;
                align-items: center;
                .div1 {
                    padding: 0 10px;
                    height: 30px;
                    border: #2c8dff 1px solid;
                    line-height: 30px;
                    text-align: center;
                    color: #2c8dff;
                    float: left;
                    border-radius: 4px;
                    cursor: pointer;
                }
                .select-div{
                    margin-left: 20px;
                    font-weight: bold;
                    font-size: 16px;
                }

                .active {
                    background: #2c8dff;
                    color: #fff;
                }
            }
        }

        .summary_Date {
            width: 100%;
            height: 50px;
            margin-top: 10px;

            .block {
                width: 20%;
                float: left;
                &.w12{
                    width: 12%;
                }

                .el-input {
                    width: 66%;
                    &.w90{
                        width: 90%;
                    }
                }

                .search {
                    padding: 4px 10px;
                    border-radius: 4px;
                    background: #2c8dff;
                    color: #fff;
                    margin-left: 10px;
                }
            }
        }

        .summary_pagenum {
            width: 100%;
            margin: 10px 0;
            overflow: hidden;
            background: #f5f5f5;

            .summary_query {
                width: 20%;
                float: left;
                padding: 0 10px;
                line-height: 32px;
                letter-spacing: 1px;
                color: #585858;

                span {
                    color: #2c8dff;
                }
            }

            .block {
                float: right;
            }
        }

        .summary_content {
            width: 100%;
            border: 1px solid #eee;
            overflow: hidden;

            .summary_batch {
                width: 100%;
                overflow: hidden;
                border-bottom: 1px solid #eee;

                div {
                    float: left;

                    span {
                        display: block;
                        float: left;
                        line-height: 20px;
                        margin: 10px 0px;
                        padding: 0 20px;
                        color: #2c8dff;
                        overflow: hidden;
                        border-left: 1px #2c8dff solid;
                        cursor: pointer;
                    }
                }
            }
        }

        .summary_list {
            .scope_img {
                width: 55px;
                height: 55px;
                margin: 0 auto;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .oper {
                color: #2c8dff;
                margin-right: 10px;
                cursor: pointer;
            }
        }

        .summary_pagenum_block {
            width: 1789px;
            padding: 20px;
            position: fixed;
            right: 0;
            bottom: 0;
            background: #fff;
            z-index: 999;

            .el-pagination {
                display: flex;
                justify-content: center;
            }
        }
    }
}

.prduct_img {
    width: 500px;
    height: 500px;
}

.custom-dialog {
    ::v-deep {
        .el-dialog__body {
            max-height: 350px;
        }
    }
}

.green-box {
    color: rgb(0, 255, 64);
}

.red-box {
    color: red;
}
</style>
